module.exports = __webpack_public_path__ + "img/loan_check_list.c55a144c.png";